
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetopanchganicabs() {



    const cardData =
    {
        keyword: ' Pune to Panchgani Cab',
        heading: 'Prince Cabs: Pune to Panchgani Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Panchgani Cab services, perfect for family trips, weekend holidays, corporate travel, and scenic hill station getaways. Our fleet includes spacious sedans, SUVs, and luxury cars, all well-maintained and equipped with modern amenities to ensure a safe and enjoyable ride. With experienced drivers, flexible travel schedules, and on-time pickups, we provide a smooth journey from Pune to Panchgani. Travel comfortably and affordably with Prince Cabs’ trusted cab service to Panchgani, designed for convenience and peace of mind.',

        top: 'Top Places to Visit in Panchgani with Prince Cabs',

        "topPlaces": [
  {
    "title": "Table Land",
    "description": "Table Land is Asia’s second-largest volcanic plateau and the crown jewel of Panchgani. Spanning over 95 acres, it offers panoramic views of the surrounding hills, valleys, and Krishna River. Visitors can enjoy horse rides, nature walks, and photography on this vast stretch of flat laterite rock. During monsoons, the plateau transforms into a lush green carpet dotted with wildflowers. It is also a popular shooting location for Bollywood films. Sunset views from Table Land create an unforgettable experience for tourists."
  },
  {
    "title": "Sydney Point",
    "description": "Sydney Point is one of the most famous viewpoints in Panchgani, overlooking the Krishna Valley, Dhom Dam, and Wai town. It is named after Sir Sidney Beckwarth, the Commander in Chief during the British era. The spot offers a calm atmosphere and mesmerizing sunrise views. The cool breeze and sweeping landscapes make it a favorite among couples and photographers. It is easily accessible and often the first stop for visitors to Panchgani. On clear days, the view stretches for miles across the Sahyadris."
  },
  {
    "title": "Parsi Point",
    "description": "Parsi Point is a scenic viewpoint known for its breathtaking views of the Krishna Valley and Dhom Dam backwaters. The place gets its name from the Parsi community, which frequently visited here during the colonial period. Today, it remains a family-friendly spot with benches, telescopes, and small food stalls. Visitors can enjoy snacks while soaking in the valley’s beauty. It is especially popular at sunset when the sky paints dramatic colors. The spot’s accessibility makes it a must-visit in Panchgani."
  },
  {
    "title": "Devil’s Kitchen",
    "description": "Located near Table Land, Devil’s Kitchen is a group of natural caves steeped in mythology. Legend says the Pandavas stayed here during their exile and cooked their meals in these caves, giving the site its unique name. The caves are surrounded by lush greenery and provide a sense of mystery for explorers. Adventure seekers enjoy trekking in the area. The spot combines mythology, nature, and adventure in one. It remains a fascinating attraction for history lovers and thrill-seekers alike."
  },
  {
    "title": "Rajpuri Caves",
    "description": "Rajpuri Caves are ancient rock-cut caves surrounded by holy kunds (ponds) believed to have religious significance. Locals believe the Pandavas also stayed here during their exile. The caves house a temple dedicated to Lord Kartikeya and are considered sacred by devotees. Pilgrims often visit to take a dip in the ponds, believed to have healing powers. The atmosphere is spiritual and peaceful, attracting both devotees and history enthusiasts. The combination of myth, legend, and natural beauty makes Rajpuri a special place."
  },
  {
    "title": "Dhom Dam",
    "description": "Located on the Krishna River, Dhom Dam is a massive water reservoir that supplies water to nearby towns and farmlands. It has also become a popular spot for water sports and boating. Visitors can enjoy speed boats, scooters, and kayaking while taking in views of the Sahyadri ranges. The surrounding landscape is especially charming during monsoon. Many Bollywood movies have been shot here due to its picturesque backdrop. It’s a perfect blend of adventure, nature, and relaxation."
  },
  {
    "title": "Harrison’s Folly",
    "description": "Harrison’s Folly is a flat barren piece of land offering 360-degree views of Panchgani, Wai, and the Dhom Dam backwaters. It is one of the less-crowded viewpoints, making it ideal for peace seekers. Adventure lovers can enjoy paragliding and ATV rides here. The unique landscape also makes it a popular picnic spot. Visitors often come to watch sunsets and capture panoramic shots of the valley. The open expanse and calm atmosphere make it a hidden gem in Panchgani."
  },
  {
    "title": "Kamalgad Fort",
    "description": "Situated near Wai, Kamalgad Fort is a historic hill fort that attracts trekkers and history enthusiasts. Built during the Maratha period, the fort offers panoramic views of the Dhom Dam and surrounding valleys. The trek to the fort is challenging but rewarding with scenic trails. The fort’s ruins, caves, and legends add to its mystery. Locals believe it was once used as a prison. Today, it is a destination where history meets adventure in the heart of nature."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Located on the Mahabaleshwar–Panchgani road, Lingmala Waterfall is a breathtaking natural attraction. The waterfall has two levels – a smaller one ideal for casual visitors and a larger one that plunges into a deep valley. During monsoon, the falls are at their majestic best, surrounded by mist and lush greenery. Visitors can trek down for a closer look at the cascading waters. The serene atmosphere makes it a great spot for nature lovers. It is also popular for photography and picnics."
  },
  {
    "title": "Bhilar Village of Books",
    "description": "Bhilar, located near Panchgani, is India’s first ‘village of books,’ inspired by a similar concept in the UK. More than 25 locations in the village, including homes and schools, have been converted into libraries. Visitors can freely read and borrow books on topics ranging from literature to history. The initiative promotes reading culture and attracts bibliophiles from across the country. The scenic beauty of the village adds to the charm of reading in the lap of nature. It is a unique cultural and intellectual experience."
  }
],


      "services": [
    {
        "name": "Pune to Panchgani Cab Fare",
        "description": "Check the best cab fares for travel from Pune to Panchgani with our transparent pricing model. We offer competitive rates with no hidden charges, allowing you to plan your budget trip easily. Choose from a range of vehicles suited for solo, couple, or family travel with reliable service and comfort guaranteed."
    },
    {
        "name": "Pune to Panchgani Taxi Fare",
        "description": "Affordable and upfront taxi fare options for your Pune to Panchgani journey. Whether you need a compact sedan or a spacious SUV, we provide accurate fare details, including tolls and driver charges, so you can travel stress-free and enjoy the scenic drive through the hills."
    },
    {
        "name": "Pune to Panchgani Innova Crysta Taxi Fare",
        "description": "Travel in a luxurious Innova Crysta from Pune to Panchgani with detailed fare information upfront. Our service includes professional drivers, AC comfort, and plenty of luggage space, making it a great option for groups or families looking for a smooth, worry-free ride."
    },
    {
        "name": "Pune to Panchgani Innova",
        "description": "Book Innova cabs for your Pune to Panchgani trip and enjoy spacious seating, smooth suspension, and top-notch comfort. Ideal for family vacations or group travel, the Innova ensures a relaxing experience throughout the winding roads of the Western Ghats."
    },
    {
        "name": "Pune to Tapola Cab Booking",
        "description": "Plan a memorable trip from Pune to Tapola with our reliable cab booking service. Whether it’s a day trip or overnight stay, our cabs are available with professional drivers, on-time pickups, and comfortable vehicles to make your journey to this beautiful lake destination smooth and enjoyable."
    },
    {
        "name": "Pune to Panchgani to Mahabaleshwar Cab Service",
        "description": "Explore the hill stations of Panchgani and Mahabaleshwar with a single cab service from Pune. Our multi-destination package allows you to cover both locations with a dedicated vehicle and driver, giving you the flexibility to explore attractions at your own pace while enjoying a comfortable and scenic drive."
    },
    {
        "name": "Pune to Panchgani Etios Taxi",
        "description": "Book an Etios taxi from Pune to Panchgani for an economical yet comfortable ride. Ideal for couples or small families, this fuel-efficient sedan offers air-conditioned interiors, smooth rides, and professional drivers, ensuring a hassle-free travel experience at budget prices."
    },
    {
        "name": "Pune to Panchgani Dzire Cab",
        "description": "Swift Dzire cabs from Pune to Panchgani are perfect for solo travelers and small families seeking a cost-effective and reliable ride. Enjoy AC comfort, well-maintained cars, and courteous drivers with timely service for a relaxed journey through the hills."
    },
    {
        "name": "Pune to Panchgani Family Cab",
        "description": "Travel comfortably with your loved ones in our family cabs from Pune to Panchgani. These spacious vehicles are designed to accommodate luggage, kids, and elders with ease, offering door-to-door service, AC interiors, and experienced drivers to make your trip enjoyable and safe."
    },
    {
        "name": "Pune to Panchgani Round Trip Taxi",
        "description": "Book a round trip taxi from Pune to Panchgani with guaranteed return at your convenience. Whether it's a same-day trip or a multi-day stay, our round-trip service offers flexibility, time savings, and the assurance of a trusted cab for both legs of your journey."
    },
    {
        "name": "Pune to Panchgani Tour Package",
        "description": "Discover the beauty of Panchgani with our curated cab tour packages from Pune. These packages include sightseeing, round-trip travel, driver charges, and optional guides, making it easy for families or groups to enjoy a well-planned, memorable vacation."
    },
    {
        "name": "Pune to Panchgani One Way Taxi",
        "description": "Need a one-way ride to Panchgani from Pune? Our one-way taxi service offers affordable rates, clean cars, and timely service. Ideal for travelers planning to stay longer or return by other means, this option saves cost without compromising on quality."
    },
    {
        "name": "Pune to Panchgani Affordable Cab",
        "description": "Book budget-friendly cabs from Pune to Panchgani without compromising on comfort or safety. Our affordable cab services include clean vehicles, skilled drivers, and clear pricing, making them ideal for students, solo travelers, or weekend explorers."
    }
],
"tableData": [
    ["Pune to Panchgani Cab Fare", "Pune to Panchgani Taxi Fare"],
    ["Pune to Panchgani Innova Crysta Taxi Fare", "Pune to Panchgani Innova"],
    ["Pune to Tapola Cab Booking", "Pune to Panchgani to Mahabaleshwar Cab Service"],
    ["Pune to Panchgani Etios Taxi", "Pune to Panchgani Dzire Cab"],
    ["Pune to Panchgani Family Cab", "Pune to Panchgani Round Trip Taxi"],
    ["Pune to Panchgani Tour Package", "Pune to Panchgani One Way Taxi"],
    ["Pune to Panchgani Affordable Cab", ""]
],


        "whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Panchgani Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable cab service from Pune to Panchgani, ideal for family trips, weekend getaways, or leisure travel. Enjoy a scenic and comfortable journey with our on-time pickup and drop services."
    },
    {
        "WhyChooseheading": "Comfortable Vehicles for Hill Travel",
        "WhyChoosedescription": "Our cabs are well-maintained, air-conditioned, and spacious, offering a smooth ride through the winding roads to Panchgani. Travel in comfort with ample legroom and luggage space."
    },
    {
        "WhyChooseheading": "Skilled Drivers with Route Expertise",
        "WhyChoosedescription": "Our experienced drivers are familiar with the Pune to Panchgani route and local terrain, ensuring safe driving through hills and timely arrivals at your destination."
    },
    {
        "WhyChooseheading": "Customizable Packages to Match Your Plans",
        "WhyChoosedescription": "Prince Cabs provides flexible booking options including one-way, round-trip, or extended stays in Panchgani. We tailor your travel plan to suit your schedule and requirements."
    },
    {
        "WhyChooseheading": "Hygiene-Focused, Sanitized Vehicles",
        "WhyChoosedescription": "Passenger safety is our priority. All cabs are cleaned and sanitized before every ride, and we follow strict hygiene protocols to ensure a safe and pleasant journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing & Easy Payment Options",
        "WhyChoosedescription": "Our cab fares from Pune to Panchgani are budget-friendly and clearly communicated—no hidden charges. We accept payments via UPI, credit/debit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Dedicated Support Throughout Your Trip",
        "WhyChoosedescription": "Our customer support team is available 24/7 to help with bookings, queries, or travel changes. Count on us for a smooth and stress-free Pune to Panchgani cab experience."
    }
]


















    }

    const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Panchgani cab services?',
        answer: 'Yes, Prince Cabs offers reliable Pune to Panchgani cab services, ideal for weekend trips, family vacations, or leisure travel.',
    },
    {
        question: 'What types of cabs are available for the Pune to Panchgani route?',
        answer: 'We provide a variety of cabs including hatchbacks, sedans, SUVs, and tempo travellers to accommodate different group sizes and preferences.',
    },
    {
        question: 'Are the cabs well-equipped for a comfortable journey?',
        answer: 'Yes, all our cabs are equipped with air conditioning, clean interiors, comfortable seating, and experienced drivers for a smooth journey.',
    },
    {
        question: 'Can I plan custom stops on the way to Panchgani?',
        answer: 'Absolutely! You can customize your trip with preferred pickup and drop locations, along with sightseeing or refreshment stops along the route.',
    },
    {
        question: 'What are the charges for a Pune to Panchgani cab?',
        answer: 'Cab charges depend on the vehicle type, trip duration, and any additional requests. Contact Prince Cabs for a personalized and affordable quote.',
    },
    {
        question: 'How can I book a Pune to Panchgani cab with Prince Cabs?',
        answer: 'Booking is easy—contact us via our website or phone with your travel details, and we’ll help you select the best cab for your trip.',
    },
    {
        question: 'Are the cabs sanitized and regularly maintained?',
        answer: 'Yes, we ensure that every vehicle is thoroughly sanitized and well-maintained to offer a safe and hygienic travel experience.',
    },
];

const testimonials = [
    {
        name: "Mr. Akshay Pawar",
        position: "Frequent Traveler",
        text: "I booked a Pune to Panchgani cab with Prince Cabs. The driver was punctual and courteous, and the vehicle was very clean. Excellent service!",
        image: "/img/testimonial/testimonial-thumb-panchgani-1.png",
    },
    {
        name: "Mrs. Rutuja Shinde",
        position: "Family Trip Organizer",
        text: "Our family trip to Panchgani was hassle-free thanks to Prince Cabs. The SUV was spacious and the journey was smooth.",
        image: "/img/testimonial/testimonial-thumb-panchgani-2.png",
    },
];























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panchgani Cab",
  "image": "https://princecab.com/assets/images/pune-panchgani-cab.jpg",
  "description": "Book Pune to Panchgani cab with Prince Cabs for affordable and reliable taxi options. Choose from AC sedans, SUVs, and tour packages. One-way and round trip cabs available with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.5",
    "ratingCount": "6890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-panchgani-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Panchgani Cab | Reliable Taxi Fare & Tour Package | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Panchgani cab with Prince Cabs – Affordable fares, clean cabs, and verified drivers. Options include Dzire, Etios, Innova, and family SUVs. One-way and round trip bookings available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Panchgani Cab Fare, Pune to Panchgani Taxi Fare, Pune to Panchgani Innova Crysta Taxi Fare, Pune to Panchgani Innova, Pune to Tapola Cab Booking, Pune to Panchgani to Mahabaleshwar Cab Service, Pune to Panchgani Etios Taxi, Pune to Panchgani Dzire Cab, Pune to Panchgani Family Cab, Pune to Panchgani Round Trip Taxi, Pune to Panchgani Tour Package, Pune to Panchgani One Way Taxi, Pune to Panchgani Affordable Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopanchganicabs;